
<app-radio-input-group #childDiagnosisComponent [indication]="indication" [labelName]="'Diagnosis'" [controlName]="'diagnosis'" 
 [controlDisplayName]="'Diagnosis'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedControlSelectionChangedHandler($event)"></app-radio-input-group>
<div class="criteria-section" *ngIf="showCriteriaSection()">
  <br />
  <kendo-label
    [text]="'Dyslipidemia criteria'"
    class="input-label-header"
  ></kendo-label>
  <hr class="input-label-header-hr" />
  <p>
    Must satisfy 
    <kendo-dropdownlist style="width: 75px; margin-left: 0.35rem; margin-right: 0.35rem;"
      [data]="getNumberOfSelectionsCheckedList()"
      [(ngModel)]="numberOfSelectionsValue"
      [size]="'small'"
      (valueChange)="updateSelections()"
    ></kendo-dropdownlist> of the selected following:
  </p>
  <div *ngIf="hasErrors" class="row">
    <div class="col">
      <div class="alert alert-danger d-flex align-items-center alert-danger-custom" role="alert">
        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-octagon-fill"/></svg>
        <div style="color: white">At least 1 criteria selection is required</div>
      </div>
    </div>
  </div>
</div>
<form [formGroup]="formGroup" [hidden]="!showCriteriaSection()">
  <div class="row">
    <div class="col-4"></div>
    <div class="col-4" style="text-align: center;">
      <kendo-label text="Male"></kendo-label>
    </div>
    <div class="col-4" style="text-align: center;">
      <kendo-label text="Female"></kendo-label>
    </div>
  </div>
  <div class="form-check" *ngFor="let inputOption of dyslipidemiaCriteriaOptions">
    <div class="row">
      <div class="col-4 mb-1">
        <input class="form-check-input" type="checkbox" (change)="updateSelections()" [formControlName]="inputOption.checkbox.name" #dyslipidemiaCheckbox />
        <kendo-label [for]="dyslipidemiaCheckbox" [text]="inputOption.checkbox.displayName + ' ' + inputOption.checkbox.details + ' (' + indication.units + ')'"></kendo-label>
      </div>
      <div class="col-4 mb-1">
        <kendo-textbox
            [formControlName]="inputOption.male.name"
            placeholder=""
            [clearButton]="true"
            [disabled]="!inputEnabled(inputOption)"
            [ngClass]="!inputEnabled(inputOption) ? 'disable-input' : ''"
            (valueChange)="updateSelections()"
            [maxlength]="4"
            [minlength]="1"
          >
          </kendo-textbox>
      </div>
      <div class="col-4 mb-1">
        <kendo-textbox
            [formControlName]="inputOption.female.name"
            placeholder=""
            [clearButton]="true"
            [disabled]="!inputEnabled(inputOption)"
            [ngClass]="{'disable-input': !inputEnabled(inputOption)}"
            (valueChange)="updateSelections()"
            [maxlength]="4"
            [minlength]="1"
          >
          </kendo-textbox>
      </div>
    </div>
  </div>
</form>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
